import { toast } from "react-toastify";
import { postAdminLogin } from "../../../apiCalls/caller";
import { userType } from "../../../Components/constants/layout";
import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";

export const loginAdmin = (user, history) => async (dispatch) => {
  try {
    let response = await postAdminLogin(user);
    if (response.success) {
      sessionStorage.setItem("authUser", JSON.stringify(response.data));
      dispatch(loginSuccess(response));
      const auth_user = response.data;
      let redirectURL = "/";
      if (auth_user.user_type === userType.ADMIN) {
        redirectURL = "/dashboard";
      } else if (auth_user.user_type === userType.BC) {
        redirectURL = "/products";
      } else if (auth_user.user_type === userType.STOCKCHECK) {
        redirectURL = "/stock-check";
      } else if (auth_user.user_type === userType.INITIALANALYSIS) {
        redirectURL = "/initial-analysis";
      } else if (auth_user.user_type === userType.FINALANALYSIS) {
        redirectURL = "/final-analysis";
      }

      history(redirectURL);
    } else {
      toast.error(response, { autoClose: 3000 });
      dispatch(apiError(response));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    sessionStorage.removeItem("authUser");

    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    //  else {
    //   response = postSocialLogin(data);
    // }

    const socialdata = await response;
    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history("/");
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
